import { lazy, mount, redirect, route } from 'navi';
import React from 'react';
import { isFeatureEnabled } from 'utils/feature-flags';
import Login from './pages/account/login';
import ApiAccess from './pages/api-access';
import FlockProfile, { FlockProfiles } from './pages/flock-profile';
import Invoice from './pages/invoice';

export default mount({
  '/': redirect('/search/dashboard'),
  '/login': route({
    view: <Login />,
  }),
  '/invoice': lazy(() => route({ view: <Invoice /> })),
  '/api-access': isFeatureEnabled('gbv')
    ? route((req) => ({
      view: <ApiAccess />,
      data: { ...req.state },
    }))
    : redirect('/404'),
  '/flock-profiles': isFeatureEnabled('gbv')
    ? mount({
      '/': route((req) => ({
        view: <FlockProfiles />,
        data: { ...req.state },
      })),
      '/:flockProfileId': route((req) => {
        const { flockProfileId } = req.params as { flockProfileId: string };

        return {
          view: <FlockProfile flockProfileId={flockProfileId} />,
          data: { ...req.state },
        };
      }),
    })
    : redirect('/404'),
  '/admin': lazy(() => import('./pages/admin/admin-routes')),
  '/account': lazy(() => import('./pages/account/account-routes')),
  '/animal': lazy(() => import('./pages/animal/animal-routes')),
  '/analysis': lazy(() => import('./pages/analysis/analysis-routes')),
  '/billing': lazy(() => import('./pages/billing/billing-routes')),
  '/catalogue': lazy(() => import('./pages/catalogues/catalogue-routes')),
  '/config': lazy(() => import('./pages/config/config-routes')),
  '/producer': lazy(() => import('./pages/producer/producer-routes')),
  '/uploads': lazy(() => import('./pages/submissions/submissions-routes')),
  '/shopping-cart': lazy(() => import('./pages/shopping-cart/shopping-cart-routes')),
  '/rugg': lazy(() => import('./pages/rugg/rugg-routes')),
  '/report': lazy(() => import('./pages/report/report-routes')),
  '/ram-team-tracking': isFeatureEnabled('rtt')
    ? lazy(() => import('./pages/ram-team-tracking/ram-team-tracking-routes'))
    : redirect('/404'),
  '/ram-team-tracking-workspace': isFeatureEnabled('rtt') 
    ? lazy(() => import('./pages/ram-team-tracking-workspace/ram-team-tracking-workspace-routes'))
    : redirect('/404'),
  '/stud-profiles': isFeatureEnabled('gbv')
    ? lazy(() => import('./pages/stud-profiles/stud-profiles-routes'))
    : redirect('/404'),
  '/search': lazy(() => import('./pages/search/search-routes')),
  '/searches': lazy(() => import('./pages/searches/searches-routes')),
  '/user': lazy(() => import('./pages/user/user-routes')),
  '/404': lazy(() => import('./pages/page-not-found/page-not-found-routes')),
  '/401': lazy(
    () => import('./pages/page-not-authorized/page-not-authorized-routes'),
  ),
});
